"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanSharkEffectHandler = exports.LoanSharkEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class LoanSharkEffectArgs {
    constructor(loanedAttributeScores) {
        this.loanedAttributeScores = loanedAttributeScores;
        this.__type = EffectType_1.EffectType.LoanShark;
        this.__typeName = "LoanShark";
        this.name = "Loan Shark";
        this.harmful = false;
    }
}
exports.LoanSharkEffectArgs = LoanSharkEffectArgs;
let LoanSharkEffectHandler = class LoanSharkEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectIds = [];
        sequence = sequence.pushSequence("parallel");
        for (const { attribute, score } of state.args.loanedAttributeScores) {
            state.meta.effectIds.push(container.applyDebuff({
                sequence,
                attackerId: state.creatorId,
                targetId: state.targetId,
                effect: new _1.MaxAttributeDecreaseEffectArgs(attribute, score),
                duration: Duration_1.Duration.Permanent,
                supernatural: true,
            }));
        }
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        for (const effectId of state.meta.effectIds) {
            container.cancelEffect(sequence, effectId);
        }
    }
};
LoanSharkEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.LoanShark)
], LoanSharkEffectHandler);
exports.LoanSharkEffectHandler = LoanSharkEffectHandler;
